import React from 'react';

const ContactPage = () => {
  return <>ContactPage</>;
};

export default ContactPage;
